/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiLocationBasedReviewsListParams } from './model/apiLocationBasedReviewsListParams';
import type { PaginatedProviderRatingList } from './model/paginatedProviderRatingList';

/**
 * Provider ratings for the homepage carousel, sorted by the visitor's IP location.

Sibling of ``SeoLocationReviewsView``: instead of a URL slug, the location comes from
the visitor's Cloudflare geo coordinates. When geo is missing or unusable (VPN, absent,
malformed, or out-of-range coordinates) or the brand has no default service yet, returns
an empty page so the frontend component hides.
 */
export const apiLocationBasedReviewsList = (
  params?: ApiLocationBasedReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedProviderRatingList>({
    url: `/api/v7/location-based-reviews/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiLocationBasedReviewsListQueryKey = (
  params?: ApiLocationBasedReviewsListParams
) => {
  return [`/api/v7/location-based-reviews/`, ...(params ? [params] : [])] as const;
};

export const getApiLocationBasedReviewsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLocationBasedReviewsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiLocationBasedReviewsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiLocationBasedReviewsList>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLocationBasedReviewsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLocationBasedReviewsList>>> = ({
    signal,
  }) => apiLocationBasedReviewsList(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiLocationBasedReviewsList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiLocationBasedReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLocationBasedReviewsList>>
>;
export type ApiLocationBasedReviewsListQueryError = ErrorType<unknown>;

export function useApiLocationBasedReviewsList<
  TData = Awaited<ReturnType<typeof apiLocationBasedReviewsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiLocationBasedReviewsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiLocationBasedReviewsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiLocationBasedReviewsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
